import { map } from 'lodash';
import { settings } from '~/config';

import { GET_BROWSING_HISTORY_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Popular Articles List Reducer
 * @param {*} state
 * @param {*} action
 */
export default function browsingHistoryList(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_BROWSING_HISTORY_LIST}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_BROWSING_HISTORY_LIST}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${GET_BROWSING_HISTORY_LIST}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
